import React from "react";
import PlayersTable from "./PlayersTable";
import styled from "styled-components";

const StyledContainerDiv = styled.div`
  // height: 75rem;
  // overflow-y: scroll;
`;

export default function Players() {
  return (
    <StyledContainerDiv>
      <PlayersTable />
    </StyledContainerDiv>
  );
}
